import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Check, AlertTriangle } from 'lucide-react';
import { Countdown } from './Countdown';
export function PricingSection() {
  return <section id="pricing" className="py-14 bg-petroleum relative overflow-hidden" data-id="element-586">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-electric to-transparent opacity-50" data-id="element-587"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-588">
        {/* Scarcity Header */}
        <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-589">
          <div className="inline-flex items-center gap-2 bg-danger/10 text-danger border border-danger/20 px-4 py-2 rounded-full text-sm font-bold mb-5" data-id="element-590">
            <AlertTriangle className="w-4 h-4" data-id="element-591" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>

          <div className="mb-5" data-id="element-592">
            <Countdown data-id="element-593" />
          </div>

          <p className="text-textsecondary mb-2" data-id="element-594">
            ⚠️ Después sube $10.000 ARS. No vuelve.
          </p>
          <p className="text-energy font-medium flex items-center justify-center gap-2" data-id="element-595">
            72% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-596">
          {/* Outer glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-gold to-electric rounded-3xl blur-xl opacity-40 animate-pulse" data-id="element-597"></div>

          {/* Frame */}
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/30" data-id="element-598">
            {/* Grid pattern background */}
            <div className="absolute inset-0 opacity-[0.10] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(245,185,66,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(245,185,66,0.7) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-599"></div>

            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-600"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-601"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-602"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-603"></div>

            <div className="relative z-10" data-id="element-604">
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="inline-flex items-center gap-2 bg-electric text-graphite border border-electric px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-electric/40" data-id="element-605">
                <Zap className="w-3.5 h-3.5 fill-graphite" data-id="element-606" />
                Acceso Instantáneo
              </motion.div>
              <h2 className="text-3xl md:text-5xl font-extrabold flex items-center justify-center gap-3 flex-wrap" data-id="element-607">
                <Zap className="w-7 h-7 md:w-9 md:h-9 text-gold fill-gold drop-shadow-[0_0_8px_rgba(255,209,102,0.6)]" data-id="element-608" />
                <span className="text-white" data-id="element-609">ELEGÍ TU</span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-gold to-electric drop-shadow-[0_0_12px_rgba(245,185,66,0.4)]" data-id="element-610">
                  PLAN
                </span>
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70" data-id="element-611"></div>
            </div>
          </div>
        </motion.div>

        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 items-center" data-id="element-612">
          {/* Basic Plan */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-graphite border border-white/10 rounded-3xl p-8 hover:border-electric/30 transition-all relative" data-id="element-613">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-petroleum border border-electric/40 text-electric font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wider flex items-center gap-1.5" data-id="element-614">
              <Zap className="w-3 h-3 fill-electric" data-id="element-615" /> Plan Esencial
            </div>

            <div className="mb-6 pt-2" data-id="element-616">
              <h3 className="text-2xl font-bold leading-tight mb-1.5 flex items-start gap-2" data-id="element-617">
                <span className="text-2xl mt-0.5 flex-shrink-0" data-id="element-618">📘</span>
                <span data-id="element-619">MEGAPACK FREELANCER</span>
              </h3>
              <p className="text-sm text-textsecondary" data-id="element-620">6 Tomos + 6 Bonos</p>
            </div>

            <div className="bg-petroleum rounded-xl p-4 mb-8" data-id="element-621">
              <p className="text-sm text-textsecondary mb-1" data-id="element-622">Ideal para:</p>
              <p className="font-medium" data-id="element-623">
                Personas que quieren empezar a ganar en USD con un sistema
                completo desde cero.
              </p>
            </div>

            <div className="mb-8" data-id="element-624">
              <span className="text-textsecondary line-through text-xl" data-id="element-625">
                $36.990
              </span>
              <div className="flex items-baseline gap-2" data-id="element-626">
                <span className="text-4xl font-extrabold text-white" data-id="element-627">
                  $19.990
                </span>
                <span className="text-textsecondary font-medium" data-id="element-628">ARS</span>
              </div>
            </div>

            <a href="#" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-petroleum to-petroleum/80 hover:from-electric/20 hover:to-electric/10 border border-electric/50 hover:border-electric text-white font-bold py-3.5 rounded-xl transition-all duration-300 flex items-center justify-between gap-3 pl-4 pr-2 shadow-md hover:shadow-lg hover:shadow-electric/20" data-id="element-629">
              <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-electric/15 border border-electric/30 flex items-center justify-center group-hover:bg-electric/25 transition-colors" data-id="element-630">
                <Zap className="w-4 h-4 text-electric fill-electric" data-id="element-631" />
              </span>
              <span className="flex-1 text-center text-sm md:text-base tracking-wide" data-id="element-632">
                QUIERO MI MEGAPACK
              </span>
              <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-electric/15 text-electric flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-633">
                <Check className="w-4 h-4" strokeWidth={3} data-id="element-634" />
              </span>
            </a>
          </motion.div>

          {/* Pro Plan */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-[#1a1a1a] to-petroleum border-2 border-electric rounded-3xl p-8 relative transform md:-translate-y-4 glow-electric" data-id="element-635">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-graphite font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1" data-id="element-636">
              <Zap className="w-4 h-4 fill-graphite" data-id="element-637" /> MÁS POPULAR
            </div>

            <h3 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-638">
              <span className="text-2xl flex-shrink-0" data-id="element-639">🚀</span>
              MEGAPACK + FREELANCER PRO
            </h3>
            <p className="text-textsecondary mb-6" data-id="element-640">
              6 Tomos + 6 Bonos + Freelancer Pro
              <br data-id="element-641" />
              El Sistema para Llegar a tus Primeros USD 1.000
            </p>

            <div className="bg-graphite/50 rounded-xl p-4 mb-8 border border-gold/20" data-id="element-642">
              <p className="text-sm text-gold mb-1" data-id="element-643">Ideal para:</p>
              <p className="font-medium" data-id="element-644">
                Quien quiere su primer cliente en 7 días con el sistema de
                retainers, prospección Pro y plan de 90 días a USD 1.000.
              </p>
            </div>

            <div className="mb-8" data-id="element-645">
              <span className="text-textsecondary line-through text-xl" data-id="element-646">
                $49.990
              </span>
              <div className="flex items-baseline gap-2" data-id="element-647">
                <span className="text-5xl font-extrabold text-white" data-id="element-648">
                  $27.990
                </span>
                <span className="text-textsecondary font-medium" data-id="element-649">ARS</span>
              </div>
            </div>

            <a href="#" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-gold via-gold to-gold hover:from-gold hover:via-gold hover:to-gold text-graphite font-extrabold rounded-2xl transition-all duration-300 transform hover:-translate-y-1 shadow-[0_0_25px_rgba(255,209,102,0.5)] hover:shadow-[0_0_40px_rgba(255,209,102,0.85)] flex items-center justify-between gap-3 pl-3 pr-3 py-3 uppercase tracking-wide overflow-hidden border-2 border-gold" data-id="element-650">
              {/* Animated sheen */}
              <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-12 pointer-events-none" data-id="element-651"></span>

              {/* Left icon badge */}
              <span className="relative z-10 flex-shrink-0 w-10 h-10 rounded-xl bg-graphite/15 backdrop-blur-sm flex items-center justify-center" data-id="element-652">
                <Zap className="w-5 h-5 fill-graphite text-graphite" data-id="element-653" />
              </span>

              {/* Centered label */}
              <span className="relative z-10 flex-1 text-center text-sm md:text-base leading-tight" data-id="element-654">
                QUIERO EL COMBO COMPLETO
              </span>

              {/* Right arrow badge */}
              <span className="relative z-10 flex-shrink-0 w-10 h-10 rounded-xl bg-graphite text-gold flex items-center justify-center transition-transform duration-300 group-hover:translate-x-0.5 shadow-md" data-id="element-655">
                <Check className="w-5 h-5" strokeWidth={3} data-id="element-656" />
              </span>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}